const steps = [
  { num: "1", icon: "ri-computer-line", title: "Sign Up Online", desc: "Complete your order in minutes from anywhere in Davenport. No office visit required to begin." },
  { num: "2", icon: "ri-file-list-3-line", title: "Get Your Checklist", desc: "We send you a personalized document checklist based on your passport type and situation." },
  { num: "3", icon: "ri-camera-line", title: "Get Your Photo", desc: "Visit any CVS, Walgreens, or UPS Store in Davenport for compliant passport photos." },
  { num: "4", icon: "ri-mail-send-line", title: "Ship Overnight", desc: "Send your documents via overnight courier using our prepaid label or drop-off instructions." },
  { num: "5", icon: "ri-shield-check-line", title: "We Review & Submit", desc: "Our team reviews everything for accuracy, then submits through our reserved courier access." },
  { num: "6", icon: "ri-passport-line", title: "Receive Your Passport", desc: "Your passport arrives via secure delivery. Track the entire process from Davenport." },
];

export default function DavenportHowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">The Process</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">How Fast Passport Center Works for Davenport</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">Six simple steps from your home in Davenport to your passport in hand.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200 relative">
              <div className="absolute top-4 right-4 text-gray-100 font-bold text-4xl font-mono">{s.num}</div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-4"><i className={`${s.icon} text-[#1A365D] text-xl`}></i></div>
              <h3 className="font-bold text-[#1A365D] text-base mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">Start My Application <i className="ri-arrow-right-line"></i></a>
        </div>
      </div>
    </section>
  );
}